import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@mui/material"
import { Dispatch, ReactElement, SetStateAction } from "react"

import { useGetUserData } from "../../hooks/useGetUserData"
import DisplayIf from "../wrappers/displayIf"

interface IAppSearchOptionProps {
    title: string
    search: string
    onClick: () => void
    icon: ReactElement
    setOpen: Dispatch<SetStateAction<boolean>>
    displayRoles?: string[]
}

/**
 * Search option for the search panel. Search options take the form of a button
 * that navigates to a specific part of the application based on the search term
 */
const AppSearchOption = ({
    title,
    search,
    onClick,
    icon,
    setOpen,
    displayRoles,
}: IAppSearchOptionProps): ReactElement => {
    const { groups } = useGetUserData()

    const shouldDisplay = displayRoles
        ? groups.some((role) => displayRoles.includes(role))
        : true

    return (
        <DisplayIf condition={shouldDisplay}>
            <ListItemButton
                disabled={!search}
                onClick={() => {
                    onClick()
                    setOpen(false)
                }}
                sx={{
                    ".icon": {
                        visibility: "hidden",
                    },
                    "&:hover .icon, &:focus .icon": {
                        visibility: "visible",
                    },
                }}
            >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText
                    primary={
                        search ? (
                            `${title}: ${search}`
                        ) : (
                            <Typography>
                                {title}: <em>enter search term to activate</em>
                            </Typography>
                        )
                    }
                />
                <ListItemIcon className="icon">
                    <ArrowForwardIosIcon />
                </ListItemIcon>
            </ListItemButton>
        </DisplayIf>
    )
}

AppSearchOption.defaultProps = {
    displayRoles: undefined,
}

export default AppSearchOption
